export default __webpack_public_path__ + "static/media/WM.a60b2415.png";